import { render } from "./AppHeaderSimple.vue?vue&type=template&id=6439119d&ts=true"
import script from "./AppHeaderSimple.vue?vue&type=script&lang=ts"
export * from "./AppHeaderSimple.vue?vue&type=script&lang=ts"

import "./AppHeaderSimple.vue?vue&type=style&index=0&id=6439119d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__